import AsteraOncologySanityTable from "./components/asteraOncologySanityTable";

const AsteraOncologySanity = () => {
  return (
    <div className="astera_oncology_sanity__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="astera_oncology_sanity__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="astera_oncology_sanity__heading text-h11 font-bold">
          PA Orders
        </div>
        <div className="astera_oncology_sanity__table-container flex-1 overflow-auto">
          <AsteraOncologySanityTable />
        </div>
      </div>
    </div>
  );
};

export default AsteraOncologySanity;
